import axios from "axios";
import CryptoJS from "crypto-js";
import store from "@/store";
import router from "@/router";
import { socketDisconnect } from "@/config/socket";

const URL_API = process.env.VUE_APP_API_CONTENIDO + "auth/";

export default {
  login(usuario, password) {
    let data = {
      usuario: usuario,
      clave: password,
    };
    return axios.post(URL_API + "login", data);
  },
  bitsUsuario(usuario) {
    return axios.get(URL_API + "userBits/" + usuario);
  },
  userInfo(id_cliente) {
    return axios.get(URL_API + "userInfo/" + id_cliente);
  },
  obtener_referencias(id_cliente) {
    return axios.get(URL_API + "userReferences/" + id_cliente);
  },
  obtener_contadores(id_usuario) {
    return axios.get(URL_API + "userCounter/" + id_usuario);
  },
  cambiarClave(form) {
    return axios.put(URL_API + "changePassword", form);
  },

  recuperarClave(form) {
    return axios.post(URL_API + "recoverPassword", form);
  },

  async setUserLogged(userLogged) {
    const expireTime = new Date(new Date().getTime() + 60 * 60 * 1500);

    sessionStorage.setItem("userImage", userLogged.imagen_b64);
    delete userLogged.imagen_b64;

    const usuarioEncriptado = CryptoJS.AES.encrypt(
      JSON.stringify(userLogged),
      process.env.VUE_APP_CRYPT_KEY
    ).toString();
    sessionStorage.setItem("userLoggedTicket", usuarioEncriptado);
    sessionStorage.setItem("userLoggedTicketExpired", expireTime);
  },
  subirImagenPerfil(form) {
    return axios.put(URL_API + "updateProfilePicture", form);
  },

  setUserImage(imagen) {
    sessionStorage.setItem("userImage", imagen);
  },

  getUserLogged() {
    let usuarioEncriptado = sessionStorage.getItem("userLoggedTicket");
    var bytes = CryptoJS.AES.decrypt(
      usuarioEncriptado,
      process.env.VUE_APP_CRYPT_KEY
    );
    var usuario = bytes.toString(CryptoJS.enc.Utf8);

    return JSON.parse(usuario);
  },
  getUserImage() {
    return sessionStorage.getItem("userImage");
  },
  async cerrarSesion(manual = true) {
    sessionStorage.removeItem("userImage");
    sessionStorage.removeItem("userLoggedTicket");
    sessionStorage.removeItem("userLoggedTicketExpired");
    if (manual) await router.push("/");
    store.dispatch("limpiarSesionData", manual);
    socketDisconnect();
  },
  isAuthenticated() {
    return sessionStorage.getItem("userLoggedTicket") !== null;
  },
};
